import { formatTimestamp } from "@/lib/datetime-utils.js";
import { getStatusDisplayText } from "@/lib/formatting-utils.js";

/**
 * Metadata field definitions for asset summary views.
 * Labels align with fleet table column headers.
 * @type {Array<{ key: string, label: string, format: string }>}
 */
export const ASSET_METADATA_FIELDS = [
  { key: "status", label: "Status", format: "status" },
  { key: "vendor", label: "Vendor", format: "text" },
  { key: "location", label: "Location", format: "text" },
  { key: "telemetrySource", label: "Telemetry", format: "text" },
  {
    key: "optimizationEnabled",
    label: "Optimization Enabled",
    format: "optimization",
  },
  { key: "lastFault", label: "Last Fault", format: "textOptional" },
  { key: "lastFaultTime", label: "Last Fault Date/Time", format: "timestamp" },
  { key: "lastUpdated", label: "Last Updated", format: "timestamp" },
  { key: "foreman", label: "Foreman", format: "textOptional" },
  { key: "horsepower", label: "Horsepower", format: "numberOptional" },
  {
    key: "compressorModel",
    label: "Compressor Model",
    format: "textOptional",
  },
  { key: "engineModel", label: "Engine Model", format: "textOptional" },
  { key: "latitude", label: "Latitude", format: "coordinate" },
  { key: "longitude", label: "Longitude", format: "coordinate" },
];

/**
 * Returns plain-text display value for a metadata field (CSV/export use).
 * @param {Object} asset
 * @param {{ key: string, format: string }} field
 * @returns {string}
 */
export function getAssetMetadataPlainText(asset, field) {
  const value = asset?.[field.key];

  switch (field.format) {
    case "status":
      return getStatusDisplayText(value);
    case "optimization":
      return value ? "Yes" : "No";
    case "timestamp":
      return value ? formatTimestamp(value) : "-";
    case "numberOptional":
      return value != null ? String(value) : "-";
    case "coordinate":
      return value != null ? String(value) : "-";
    case "textOptional":
      return value || "-";
    default:
      return value != null && value !== "" ? String(value) : "-";
  }
}
